var _defs, _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPripisy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168.65 164.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #a82f52;\n      }\n\n      .st1 {\n        fill: #eea941;\n      }\n\n      .st2 {\n        fill: #eea942;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 66.19,
    y1: 122.57,
    x2: 146.7,
    y2: 42.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.19,126.32c-.96,0-1.92-.37-2.65-1.1-1.46-1.46-1.46-3.84,0-5.3l80.51-80.51c1.46-1.46,3.84-1.46,5.3,0,1.46,1.46,1.46,3.84,0,5.3l-80.51,80.51c-.73.73-1.69,1.1-2.65,1.1Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 146.95,
    y1: 59.85,
    x2: 146.95,
    y2: 42.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.95,63.6c-2.07,0-3.75-1.68-3.75-3.75v-17.14c0-2.07,1.68-3.75,3.75-3.75s3.75,1.68,3.75,3.75v17.14c0,2.07-1.68,3.75-3.75,3.75Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 146.34,
    y1: 42.09,
    x2: 129.19,
    y2: 42.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.34,45.84h-17.14c-2.07,0-3.75-1.68-3.75-3.75s1.68-3.75,3.75-3.75h17.14c2.07,0,3.75,1.68,3.75,3.75s-1.68,3.75-3.75,3.75Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 98.09,
    y1: 48.18,
    x2: 17.58,
    y2: 128.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.58,132.95c-1.09,0-2.18-.42-3.01-1.25-1.66-1.66-1.66-4.36,0-6.02L95.08,45.17c1.66-1.66,4.36-1.66,6.02,0,1.66,1.66,1.66,4.36,0,6.02L20.59,131.7c-.83.83-1.92,1.25-3.01,1.25Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17.33,
    y1: 110.9,
    x2: 17.33,
    y2: 128.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.33,132.3c-2.35,0-4.26-1.91-4.26-4.26v-17.14c0-2.35,1.91-4.26,4.26-4.26s4.26,1.91,4.26,4.26v17.14c0,2.35-1.91,4.26-4.26,4.26Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17.95,
    y1: 128.66,
    x2: 35.09,
    y2: 128.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.09,132.92h-17.14c-2.35,0-4.26-1.91-4.26-4.26s1.91-4.26,4.26-4.26h17.14c2.35,0,4.26,1.91,4.26,4.26s-1.91,4.26-4.26,4.26Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.59,74.95c-10.76,0-19.51-8.75-19.51-19.51s8.75-19.51,19.51-19.51,19.51,8.75,19.51,19.51-8.75,19.51-19.51,19.51ZM33.59,42.94c-6.9,0-12.51,5.61-12.51,12.51s5.61,12.51,12.51,12.51,12.51-5.61,12.51-12.51-5.61-12.51-12.51-12.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.01,59.44h-13.17c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5h13.17c1.93,0,3.5,1.57,3.5,3.5s-1.57,3.5-3.5,3.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.59,134.02c-10.76,0-19.51-8.75-19.51-19.51s8.75-19.51,19.51-19.51,19.51,8.75,19.51,19.51-8.75,19.51-19.51,19.51ZM133.59,102.01c-6.9,0-12.51,5.61-12.51,12.51s5.61,12.51,12.51,12.51,12.51-5.61,12.51-12.51-5.61-12.51-12.51-12.51Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140,118.51h-13.17c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5h13.17c1.93,0,3.5,1.57,3.5,3.5s-1.57,3.5-3.5,3.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.5,124.68c-1.93,0-3.5-1.57-3.5-3.5v-13.17c0-1.93,1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5v13.17c0,1.93-1.57,3.5-3.5,3.5Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPripisy);
export default __webpack_public_path__ + "static/media/pripisy.fa075f3e2dee9ac2994f298edc510bac.svg";
export { ForwardRef as ReactComponent };